<template>
  <div class="wrapper">
    <div class="preview">
      <div class="preview__content">
        <c-loader v-if="handling" :active="handling" class="loader" />
        <img v-else-if="filePreviewUrl" :src="filePreviewUrl" alt="" class="preview-img" @click="openFile()" />
        <img v-else src="/redesign/img/userpic.svg" class="preview-empty" @click="chooseFile()" />
      </div>
      <div
        v-if="field.required"
        class="required-mark"
      />
    </div>

    <input
      ref="input"
      name="attachment[]"
      type="file"
      :accept="accept"
      hidden
      :required="field.required"
      @change="onFileChange"
    />

    <div class="actions">
      <div
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'Загрузить фотографию',
          placement: 'top',
        }"
        class="change"
      >
        <c-button size="iconic" :icon="{ icon: 'restore' }" :disabled="preview" @click="chooseFile()" />
      </div>
      <div
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'Удалить фотографию',
          placement: 'top',
        }"
        class="remove"
      >
        <c-button
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          :disabled="preview || !filePreviewUrl"
          @click="removeFile()"
        />
      </div>
    </div>

    <error-feedback v-if="sizeError" text="Размер файла не должен превышать 5Мб" />
    <error-feedback v-if="error" :text="error" />

    <FsLightbox :key="gallery.length" :toggler="lightbox" :sources="gallery" :disable-local-storage="true" />
  </div>
</template>

<script>
import FsLightbox from "fslightbox-vue";

import CButton from "@/components/controls2/Button";
import CLoader from "@/components/loader";
import ErrorFeedback from "@/components/error-feedback";

import * as fileUtils from "@/utils/files";

export default {
  components: { FsLightbox, CButton, CLoader, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: null,
      oldLink: "",
      filePreviewUrl: "",
      handling: false,
      accept: fileUtils.IMAGE_EXTENSIONS.map((ext) => `.${ext}`),
      sizeError: false,

      lightbox: false,
    };
  },

  computed: {
    gallery() {
      return this.filePreviewUrl ? [this.filePreviewUrl] : [];
    },
  },

  watch: {
    value(v) {
      this.setData(v);
    },
    sizeError(v) {
      if (v) {
        clearTimeout(this._sizeErrorTimer);
        this._sizeErrorTimer = setTimeout(() => {
          this.sizeError = false;
        }, 3000);
      }
    },
  },

  created() {
    if (this.value) {
      this.setData(this.value);
    }
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const { files, oldFiles } = value;

      if (!files || !files.length) {
        this.localValue = null;
        this.filePreviewUrl = "";
        if (oldFiles && oldFiles.length) {
          const [link] = oldFiles;
          this.oldLink = link;
          this.filePreviewUrl = link.url;
        }
      }
      
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    chooseFile() {
      this.$refs.input.click();
    },
    reset() {
      this.$refs.input.value = null;
    },
    createPreview(file) {
      return new Promise((res) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          res(event.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    checkSize(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.sizeError = true;
        return false;
      }

      return true;
    },

    onFileChange(e) {
      this.errors = [];
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      const file = files[0];

      if (!this.checkSize(file)) return;
      this.addFile(file);

      this.reset();
    },

    addFile(file) {
      this.oldLink = null;
      this.localValue = file;
      this.handling = true;

      this.$emit("input", {
        files: [file],
        oldFiles: [],
      });
      
      if (this.inited) this.$emit("change");

      this.createPreview(file)
        .then((url) => {
          this.filePreviewUrl = url;
        })
        .finally(() => {
          this.handling = false;
        });
    },

    removeFile() {
      this.localValue = null;
      this.link = null;
      this.filePreviewUrl = "";

      this.handling = false;

      this.$emit("input", {
        files: [],
        oldFiles: [],
      });
      
      if (this.inited) this.$emit("change");
    },

    openFile() {
      this.lightbox = !this.lightbox;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  position: relative;
  width: 100px;
  height: 100px;

  &__content {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 12px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
    object-position: center;
  }

  .loader {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    /deep/ {
      .loader-overlay {
        height: 100% !important;
        border: none;
      }
      .loader-icon {
        font-size: 24px;
      }
    }
  }
}
.actions {
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.change {
  margin-right: 20px;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
}

.required-mark {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1;
  font-size: 24px;
  color: red;

  &::after {
    content: '*';
  }
}
</style>
